import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { User } from 'oidc-client-ts';
import { EMPTY, catchError, from, switchMap } from 'rxjs';
import { environment } from 'src/environments/environment';
import { SplunkEvent } from '../models/SplunkEvent';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root',
})
export class SplunkService {
  userAgent = navigator.userAgent;
  constructor(
    private readonly http: HttpClient,
    private readonly authService: AuthService
  ) {}

  log(splunkEvt: SplunkEvent) {
    const headers = new HttpHeaders()
      .set('Authorization', `Splunk ${environment.splunk.token}`)
      .set('Index', `${environment.splunk.index}`)
      .set('Content-Type', 'application/x-www-form-urlencoded');

    return from(this.authService.getUser()).pipe(
      switchMap((user: User | null) => {
        const account = this.authService.getAccount();
        let evt: any = {
          environment: environment.environmentName,
          ...splunkEvt,
          userAgent: this.userAgent,
          sessionID: user?.profile.sid,
          username: user?.profile.email,
        };
        if (account) {
          evt = {
            ...evt,
            email: account?.subname,
          };
        }

        return this.http.post(`${environment.splunk.url}`, { event: evt }, { headers });
      }),
      catchError(() => {
        return EMPTY;
      })
    );
  }

  isSplunkUrl(url: string) {
    return /splunkcloudhec/.test(url);
  }
}
